// ═══════════════════════════════════════════════════════════════
//  COMPANY FACTS — the single source of truth for public claims
// ═══════════════════════════════════════════════════════════════
// These numbers used to be typed out separately on the home page, the about
// page, the lead popup, the FAQ and the design-process list. They drifted:
// the about image badge claimed 10 years while the studio was founded in 2021,
// and the two pages disagreed on the project count. Anything a visitor could
// fact-check belongs here, once.

export const FOUNDED_YEAR = 2021;

// Recomputed every year, so "years of excellence" can never go stale.
export const YEARS_ACTIVE = Math.max(1, new Date().getFullYear() - FOUNDED_YEAR);

export const WARRANTY_YEARS = 5;

export const COMPANY_FACTS = {
  foundedYear: FOUNDED_YEAR,
  years: YEARS_ACTIVE,
  yearsLabel: `${YEARS_ACTIVE}+`,
  projects: '50+',
  satisfaction: '98%',
  warrantyYears: WARRANTY_YEARS,
  warrantyLabel: `${WARRANTY_YEARS}yr`,
  warrantyPhrase: `${WARRANTY_YEARS}-Year Warranty`,
};

// The stats strip, shared by the home and about pages.
export const STAT_ITEMS = [
  { value: COMPANY_FACTS.projects,     label: 'Projects Completed' },
  { value: COMPANY_FACTS.yearsLabel,   label: 'Years of Excellence' },
  { value: COMPANY_FACTS.satisfaction, label: 'Client Satisfaction' },
  { value: COMPANY_FACTS.warrantyLabel, label: 'Warranty Promise' },
];
